import { defaultFiltro, dataInitialFilter } from "./state";
const moment = require("moment");

/**
 * Mutación para cargar el idioma del adjunto al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} idioma contiene la información de los idiomas.
 */
export function cargarIdioma(state, idioma) {
    state.idiomas = [];

    for (let i = 0; i < idioma.length; i++) {
        state.idiomas.push({ value: idioma[i].id, text: idioma[i].lista });
    }
}

export function setAdjuntosArchivo(state, adjuntosArchivo) {
    state.adjuntosArchivo = adjuntosArchivo;
}

/**
 * Mutación para limpiar el filtro del buscador de adjuntos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiarFiltroAdjuntos(state) {
    Object.assign(state.filtro, defaultFiltro());
}

/**
 * Mutación para cargar el tipo de adjunto al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tipo contiene la información de los tipos de adjunto.
 */
export function cargarTipo(state, tipo) {
    state.tipos = [];

    for (let i = 0; i < tipo.length; i++) {
        state.tipos.push({ value: tipo[i].id, text: tipo[i].lista });
    }
}

/**
 * Mutación para resetear el tipo de adjunto.
 *
 * @export
 * @param {*} state
 */
export function resetSelectedAdjunto(state) {
    state.selectedAdjunto.tipo = null;
}

/**
 * Mutación para asignar los adjuntos procesados por el usuario
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} adjuntos contiene la información de los adjuntos procesados.
 */
export function setAdjuntosProcesados(state, adjuntos) {
    for (let i = 0; i < adjuntos.length; i++) {
        switch (adjuntos[i].tipo) {
            case '154':
                adjuntos[i].tipo = "FDS";
                break;
            case '155':
                adjuntos[i].tipo = "MSDS";
                break;
            case '156':
                adjuntos[i].tipo = "ET";
                break;
            case '157':
                adjuntos[i].tipo = "TE";
                break;
            case '158':
                adjuntos[i].tipo = "AR";
                break;
            case '159':
                adjuntos[i].tipo = "Otro";
                break;
            case '164':
                adjuntos[i].tipo = "Por validar";
                break;
            case '177':
                adjuntos[i].tipo = "SDS";
                break;
            default:
                adjuntos[i].tipo = "Por validar";
            break;
        }
    }
    state.adjuntosProcesados = adjuntos;
}

/**
 * Mutación para cargar los estados de FDS del adjunto al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} estadoFds contiene la información de los estados de FDS del adjunto.
 */
export function cargarEstadoFds(state, estadoFds) {
    state.estados_fds = [];
    state.estados_fds = estadoFds
}

/**
 * Mutación para limpiar el formulario de adjuntos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiarAdjunto(state) {
    state.selectedAdjunto.idioma = '',
    state.selectedAdjunto.tipo = '',
    state.selectedAdjunto.estado_fds = '',
    state.selectedAdjunto.observacion = '',
    state.selectedAdjunto.avatar = '',
    state.selectedAdjunto.fecha = '',
    state.selectedAdjunto.cumple_decreto = '',
    state.adj = '',
    state.selectedAdjunto.company_updated_id = ''
}


/**
 * Mutación para cargar los adjuntos de un producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} adj contiene la información de los adjuntos.
 */
export function cargarListadoAdj(state, adj) {
    state.adjuntos = [];
   /*  adj.data.data.forEach((adt) => {
        let fechaActual = moment().format('YYYY-MM-DD');
        const fechaVencimiento = moment(adt.fechavencimiento);
        if (fechaVencimiento.isValid()) {
            adt.diasFaltantes = fechaVencimiento.diff(
                fechaActual,
                "days"
            );
        }
    }); */
    state.adjuntos = adj.data
}

export function setPage(state, page) {
    state.filtro.page = page
    state.filter.page = page
}

export function setPerPage(state, perPage) {
    state.filtro.page = 1
    state.filter.perPage = perPage
}

export function setPageInactivo(state, page) {
    state.filtro.pageInactivo = page
    state.filter.pageInactivo = page
}

export function setPerPageInactivo(state, perPage) {
    state.filtro.pageInactivo = 1
    state.filter.perPageInactivo = perPage
}

export function setIdProducto(state, id) {
    state.id_producto = id
}

/**
 * Mutación para cargar las asignaciones de un adjunto de un producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} asig contiene la información de las asignaciones.
 */
export function cargarAsignaciones(state, asig) {

    state.selectedAdjunto.asignaciones = asig.asignaciones;
    state.selectedAdjunto.asignaciones_ori = asig.asignaciones;
}

/**
 * Mutación que carga la url para descargar el adjunto.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} url contiene la información de la url de descarga.
 */
export function setUrlAdjunto(state, url) {

    state.urlDescarga = url;


}


/**
 * Mutación que cambia el valor del estado todosAsignados, se utiliza en views/productos/adjuntos/TablaAsig.Vue.
 *
 * @param {*} state contiene la informacion de variables.
 * @param {*} todos contiene la información a ser seteada en el estado.
 */

export function setTodosAsignados(state, todos) {
    state.todosAsignados = todos;
}

/**
 * Mutación que cambia el valor del indice todo del estado todos, se utiliza en views/productos/adjuntos/TablaAsig.Vue
 * cuando el usuario presiona el check todas para asigar el adjunto en todas las empresas asignadas al producto de ese adjunto
 *
 * @param {*} state contiene la informacion de variables.
 * @param {*} todo contiene la información a ser seteada en el estado.
 */

export function setTodosAsignadosObjeto(state, todo) {
    state.todos.todo = todo;
}

/**
 * Mutación que cambia el valor del indice id_adjunto del estado todos, se utiliza en views/productos/adjuntos/TablaAsig.Vue
 *
 * @param {*} state contiene la informacion de variables.
 * @param {*} id contiene la información a ser seteada en el estado.
 */

export function setIdAdjuntoTodos(state, id) {
    state.todos.id_adjunto = id;
}


/**
 * Cambia el estado del indice asignado de state.selectedAdjunto.asignaciones.
 *
 *
 * @param {*} state contiene la informacion de variables.
 * @param {*} estado contiene la información a ser seteada en el estado.
 */

export function resetAsignaciones(state, estado) {
    for(let i = 0; i < state.selectedAdjunto.asignaciones.length; i++){
        state.selectedAdjunto.asignaciones[i].asignado = estado
    }
}

export function setModalVer(state, ver) {
    state.modal.ver = ver
}


export function setAdjuntoCargado(state, adjunto_cargado) {
    state.adjunto_cargado = adjunto_cargado
}

export function setAction(state, accion) {
    state.accion = accion
}

/**
 * Mutación para setear el adjunto seleccionado.
 * @param {*} state
 * @param {*} adjunto
 */
export function setAdjunto(state, adjunto) {
    state.selectedAdjunto = adjunto
}

/**
 * Mutación para cargar los adjuntos de un producto químico.
 *
 * @param {*} state
 * @param {*} nextAttachments: nuevos adjuntos.
 * @author Fernando Claros
 */
export function setAttachments(state, nextAttachments) {
    state.attachments = nextAttachments
}

/**
 * Mutación para setear los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDataFilter(state) {
    state.filter = dataInitialFilter()
}


/**
 * Setear los datos de tarjetas de emergencia.
 *
 * @author Paul Valencia
 */
export function setTotalTE(state, data) {
    state.totalTe = data
}

/**
 * Agregar adjuntos fds mds
 *
 * @author Paul Valencia
 */
export function setAttachmentsFdsMsds(state, data) {
    state.attachmentsFdsMsds = data
}


/**
 * Agregar adjunto creado en paso a paso.
 *
 * @author Paul Valencia
 */
export function setAttachmenteCreated(state, attachmenteCreated) {
    state.attachmenteCreated = attachmenteCreated
}

/**
 * Setear información de historico de adjuntos.
 *
 * @author Paul Valencia
 */
export function setHistoricalRevisionAttach(state, historicalRevisionAttach) {
    state.historicalRevisionAttach = historicalRevisionAttach
}



/**
 * Loader al cambiar.
 *
 * @author Paul Valencia
 */
export function toogleLoaderFormRevAdj(state, loaderFormRevAdj) {
    state.loaderFormRevAdj = loaderFormRevAdj
}
